var render = function () {
  var _vm$uploadFile$name, _vm$uploadFile, _vm$uploadFile$name2, _vm$uploadFile2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "UploadFileList",
      "extra-items": _vm.isReadOnly ? [{
        text: (_vm$uploadFile$name = (_vm$uploadFile = _vm.uploadFile) === null || _vm$uploadFile === void 0 ? void 0 : _vm$uploadFile.name) !== null && _vm$uploadFile$name !== void 0 ? _vm$uploadFile$name : ''
      }] : _vm.isEditing ? [{
        text: (_vm$uploadFile$name2 = (_vm$uploadFile2 = _vm.uploadFile) === null || _vm$uploadFile2 === void 0 ? void 0 : _vm$uploadFile2.name) !== null && _vm$uploadFile$name2 !== void 0 ? _vm$uploadFile$name2 : '',
        to: 'UploadFileView',
        params: _vm.$route.params.upload_file_id
      }, _vm.displayText('upload_file.edit_file_title', '編輯檔案')] : [_vm.displayText('upload_file.create_file_title', '新增檔案')]
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isReadOnly ? _vm.displayText('upload_file.view_file_title', "查看檔案") : _vm.isEditing ? _vm.displayText('upload_file.edit_file_title', "編輯檔案") : _vm.displayText('upload_file.create_file_title', "新增檔案")) + " ")]), _c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": '*' + _vm.displayText('upload_file.field_name', '檔案名稱')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.uploadFile.name.$error ? false : null,
      "readonly": _vm.isReadOnly || _vm.isEditing
    },
    model: {
      value: _vm.uploadFile.name,
      callback: function callback($$v) {
        _vm.$set(_vm.uploadFile, "name", $$v);
      },
      expression: "uploadFile.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.uploadFile.name.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText('upload_file.validation_required', '此欄位為必填')) + " ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": '*' + _vm.displayText('upload_file.field_url', 'URL')
    }
  }, [_c('button', {
    staticClass: "\n                    btn btn-link\n                    px-2\n                    text-dark\n                    align-self-start\n                    upload-button\n                  "
  }, [_c('b-form-file', {
    attrs: {
      "disabled": _vm.isReadOnly,
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "change": function change($event) {
        return _vm.upload($event);
      }
    }
  }), !!_vm.uploadFile.file_url ? _c('a', {
    staticClass: "btn-sm ",
    class: _vm.isReadOnly ? 'btn-outline-secondary' : 'btn-outline-danger',
    on: {
      "click": _vm.handleDelete
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })]) : _vm._e(), _c('a', {
    staticStyle: {
      "word-break": "break-all"
    },
    attrs: {
      "href": _vm.uploadFile.file_url,
      "target": "_blank"
    }
  }, [_c('small', [_vm._v(" " + _vm._s(_vm.displayText('upload_file.field_upload_file_current_path', '目前路徑')) + "：" + _vm._s(_vm.uploadFile.file_url || _vm.displayText('upload_file.field_upload_file_not_uploaded', '未上傳')) + " ")])])], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.uploadFile.file_url.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText('upload_file.validation_required', '此欄位為必填')) + " ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayText('upload_file.field_description', '檔案描述')
    }
  }, [_c('b-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.uploadFile.description.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.uploadFile.description,
      callback: function callback($$v) {
        _vm.$set(_vm.uploadFile, "description", $$v);
      },
      expression: "uploadFile.description"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.uploadFile.description.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText('upload_file.validation_required', '此欄位為必填')) + " ")])], 1), _vm.categoryOptions.length > 0 ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayText('upload_file.field_category_type', '檔案分類')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "options": _vm.categoryOptions,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.uploadFile.category,
      callback: function callback($$v) {
        _vm.$set(_vm.uploadFile, "category", $$v);
      },
      expression: "uploadFile.category"
    }
  })], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayText('upload_file.field_is_enabled', '是否啟用')
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.uploadFile.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.uploadFile, "is_enabled", $$v);
      },
      expression: "uploadFile.is_enabled"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayText('upload_file.field_start_at', '開始時間')
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50 mr-2"
  }, [_c('datepicker', {
    attrs: {
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isReadOnly,
      "clear-button": ""
    },
    model: {
      value: _vm.uploadFile.start_at,
      callback: function callback($$v) {
        _vm.$set(_vm.uploadFile, "start_at", $$v);
      },
      expression: "uploadFile.start_at"
    }
  })], 1), _c('div', {
    staticClass: "w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control'],
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.startTime,
      callback: function callback($$v) {
        _vm.startTime = $$v;
      },
      expression: "startTime"
    }
  })], 1)]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.uploadFile.start_at.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText('upload_file.validation_required', '此欄位為必填')) + " ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayText('upload_file.field_end_at', '結束時間')
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50 mr-2"
  }, [_c('datepicker', {
    attrs: {
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isReadOnly,
      "clear-button": ""
    },
    model: {
      value: _vm.uploadFile.end_at,
      callback: function callback($$v) {
        _vm.$set(_vm.uploadFile, "end_at", $$v);
      },
      expression: "uploadFile.end_at"
    }
  })], 1), _c('div', {
    staticClass: "w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control'],
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.endTime,
      callback: function callback($$v) {
        _vm.endTime = $$v;
      },
      expression: "endTime"
    }
  })], 1)]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.uploadFile.end_at.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText('upload_file.validation_required', '此欄位為必填')) + " ")])], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(_vm._s(_vm.displayText('upload_file.go_back_button_text', '返回')) + " ")]), !_vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.displayText('upload_file.submit_button_text', '儲存')))]) : _vm._e()], 1)])], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }